/**
 * @generated SignedSource<<b7707a769366082aa1831645744894d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type JwtService = "EDITOR" | "STUDIO" | "UPLOAD" | "%future added value";
export type authJwtQuery$variables = {
  event?: string | null | undefined;
  service: JwtService;
};
export type authJwtQuery$data = {
  readonly jwt: string;
};
export type authJwtQuery = {
  response: authJwtQuery$data;
  variables: authJwtQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "event"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "service"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "event",
        "variableName": "event"
      },
      {
        "kind": "Variable",
        "name": "service",
        "variableName": "service"
      }
    ],
    "kind": "ScalarField",
    "name": "jwt",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "authJwtQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "authJwtQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2cb9802352932719ddd72c7fa2904507",
    "id": null,
    "metadata": {},
    "name": "authJwtQuery",
    "operationKind": "query",
    "text": "query authJwtQuery(\n  $service: JwtService!\n  $event: ID\n) {\n  jwt(service: $service, event: $event)\n}\n"
  }
};
})();

(node as any).hash = "a5f59b40c4ee4220669826c549eddaef";

export default node;
